<div class="pt-5 pb-4 position-relative"></div>
<div class="container">
  <div class="row mb-2">
    <div class="col-md-12">
      <nav
        style="
          --bs-breadcrumb-divider: url(
            &#34;data:image/svg + xml,
            %3Csvgxmlns=&quot;http://www.w3.org/2000/svg&quot;width=&quot;8&quot;height=&quot;8&quot;%3E%3Cpathd=&quot;M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z&quot;fill=&quot;%236c757d&quot;/%3E%3C/svg%3E&#34;
          );
        "
        aria-label="breadcrumb"
      >
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a class="nn" routerLink="/bookings">Bookings</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ kodeBooking }}
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="card" *ngIf="bookings">
    <div class="card-body">
      <div
        *ngIf="bookings.status != 'WAITING PAYMENT'; else lainNya"
        class="row"
      >
        <div class="col md-6 text-start">
          <span><strong>Booking Info :</strong></span>
          <h4 class="mb-4" style="color: var(--warna-2)">{{ kodeBooking }}</h4>
        </div>
        <div class="col-md-6 text-end mb-4">
          <span
            class="badge {{ getStatusClass() }}"
            style="font-size: 0.8rem"
            (click)="onStatusClick()"
          >
            {{ getFormattedStatus() }}
          </span>
        </div>
        <hr />
      </div>

      <ng-template #lainNya>
        <div class="row mb-4">
          <div class="col-md-6 text-start mb-4">
            <h5 class="fs-14" style="color: var(--warna-2)">
              {{ kodeBooking }}
            </h5>
            <span
              class="badge {{ getStatusClass() }}"
              style="font-size: 0.9rem"
            >
              {{ getFormattedStatus() }}
            </span>
          </div>

          <div class="col-md-6 text-end mb-4">
            <span class="fs-14">Time Left to Pay</span>
            <div class="text-danger">
              <h5 [ngClass]="{ 'text-danger': remainingMinutes < 60 }">
                {{ paymentCountdown }}
              </h5>
            </div>
          </div>

          <hr />
        </div>
      </ng-template>

      <div class="row mb-4">
        <div class="col-md-6 text-start mb-4">
          <div class="d-flex align-items-center flex-wrap">
            <div class="me-2">
              <a
                [routerLink]="'/detail-boat/' + slugify(bookings.nama_kapal)"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  [src]="imgUrl"
                  alt="Cruise Image"
                  class="rounded-circle"
                  style="width: 75px; height: 75px; object-fit: cover"
                />
              </a>
            </div>
            <div>
              <a
                [routerLink]="'/detail-boat/' + slugify(bookings.nama_kapal)"
                target="_blank"
                rel="noopener noreferrer"
                style="text-decoration: none"
              >
                <h5 style="color: var(--warna-2)" class="mb-1">
                  {{ bookings.nama_kapal }}
                </h5>
              </a>
              <div class="title-list text-secondary">
                <p
                  class="d-flex align-items-center pe-2 me-2 border-end border-light fw-normal"
                >
                  <i class="fas fa-ship me-2"></i>{{ bookings.boat_kategori }}
                </p>
                <p
                  class="d-flex align-items-center pe-2 me-2 border-end border-light fw-normal"
                >
                  <i class="fa fa-map-marker me-2"></i>{{ bookings.destinasi }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-end mb-4">
          <h4 class="mb-4" style="color: var(--warna-2)">
            {{ bookings.trip_kategori }}
          </h4>
        </div>

        <hr />
      </div>

      <div class="row mb-4">
        <div class="col-md-12 text-start">
          <h5 style="color: var(--warna-2)" class="mb-1">Booking Details</h5>
        </div>
      </div>

      <div class="row gy-3 mb-4">
        <div class="col-lg-3">
          <h5 class="fs-14">Duration</h5>
          <p class="text-gray-6 fs-16 text-secondary">{{ bookings.durasi }}</p>
        </div>
        <div class="col-lg-3">
          <h5 class="fs-14">Date</h5>
          <p class="text-gray-6 fs-16 text-secondary">{{ tgl }}</p>
        </div>
        <div class="col-lg-3">
          <h5 class="fs-14">Guest(s)</h5>
          <p class="text-gray-6 fs-16 text-secondary">
            {{ bookings.guests + "x Persons" }}
          </p>
        </div>
        <div class="col-lg-3">
          <h5 class="fs-14">Accommodation</h5>
          <p class="text-gray-6 fs-16 text-secondary">
            {{ getAccomodationText() }}
          </p>
        </div>

        <hr />
      </div>

      <div class="row mb-4">
        <div class="col-md-12 text-start">
          <h5 style="color: var(--warna-2)" class="mb-1">Guest Info</h5>
        </div>
      </div>

      <div class="row gy-3">
        <!-- <div class="col-lg-4">
                    <h5 class="fs-14">Full Name</h5>
                    <p class="text-gray-6 fs-16 text-secondary">{{ tamu.nama_pelanggan }}</p>
                </div>
                <div class="col-lg-4">
                    <h5 class="fs-14">Email</h5>
                    <p class="text-gray-6 fs-16 text-secondary">{{ tamu.email_pelanggan }}</p>
                </div>
                <div class="col-lg-4">
                    <h5 class="fs-14">Phone Number</h5>
                    <p class="text-gray-6 fs-16 text-secondary">{{ tamu.whatsapp_number }}</p>
                </div> -->
        <div class="col-lg-12">
          <h5 class="fs-14">Notes</h5>
          <p class="text-gray-6 fs-16 text-secondary">{{ bookings.notes }}</p>
        </div>

        <hr />
      </div>

      <!-- Guest Details -->
      <div class="row mb-3" *ngIf="bookings">
        <div class="col-md-12 text-start">
          <h5 style="color: var(--warna-2)" class="mb-1">Guest Details</h5>
          <p class="text-muted small mb-0">
            Please complete details for each guest. You can save frequent
            travelers as templates for future bookings.
          </p>
        </div>
      </div>

      <form
        [formGroup]="guestForm"
        (ngSubmit)="saveAllGuests()"
        *ngIf="guestForm"
      >
        <div>
          <div
            *ngFor="let guest of guestsArray.controls; let i = index"
            class="card mb-2"
            style="border: 1px solid var(--bs-border-color-translucent)"
          >
            <div
              class="card-body d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <div>
                <strong>Guest {{ i + 1 }}</strong>
                <span *ngIf="guest.get('full_name')?.value">
                  — {{ guest.get("full_name")?.value }}
                </span>
                <span
                  *ngIf="!guest.get('full_name')?.value"
                  class="text-muted fst-italic"
                >
                  — not filled
                </span>
                <span
                  *ngIf="guest.get('document_number')?.value"
                  class="text-muted ms-2"
                >
                  •
                  {{
                    guest.get("document_type")?.value === "passport"
                      ? "Passport"
                      : "ID"
                  }}: {{ guest.get("document_number")?.value }}
                </span>
                <span
                  *ngIf="guest.get('document_file_name')?.value"
                  class="text-success ms-2"
                >
                  • <i class="fa fa-paperclip"></i>
                  {{ guest.get("document_file_name")?.value }}
                  <a
                    *ngIf="guest.get('document_view_token')?.value"
                    [href]="getDocumentUrl(i)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="ms-1"
                  >
                    View
                  </a>
                </span>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="openGuestModal(i)"
              >
                <i class="fa fa-edit me-1"></i> Edit
              </button>
            </div>
          </div>
        </div>

        <div class="text-end mb-4 mt-3">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="savingGuests"
          >
            <span
              *ngIf="savingGuests"
              class="spinner-border spinner-border-sm me-1"
            ></span>
            {{ savingGuests ? "Saving..." : "Save Guest Details" }}
          </button>
        </div>

        <hr />
      </form>

      <!-- Guest Edit Modal -->
      <ng-container *ngIf="editingGuestGroup as eg">
        <div
          class="modal fade show d-block"
          tabindex="-1"
          role="dialog"
          style="overflow: hidden"
          (click)="closeGuestModal()"
        >
          <div
            class="modal-dialog modal-lg modal-dialog-centered"
            style="max-height: calc(100vh - 2rem)"
            role="document"
            (click)="$event.stopPropagation()"
          >
            <div class="modal-content" style="max-height: calc(100vh - 2rem)">
              <div
                [formGroup]="eg"
                class="d-flex flex-column"
                style="max-height: calc(100vh - 2rem); min-height: 0"
              >
                <div class="modal-header">
                  <h5 class="modal-title">
                    Edit Guest {{ (editingGuestIndex ?? 0) + 1 }}
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="closeGuestModal()"
                  ></button>
                </div>
                <div
                  class="modal-body"
                  style="overflow-y: auto; flex: 1 1 auto"
                >
                  <div class="row mb-3" *ngIf="templates.length > 0">
                    <div class="col-md-12">
                      <label class="form-label fs-14"
                        >Load from saved template</label
                      >
                      <select
                        class="form-select form-select-sm"
                        (change)="
                          loadTemplate(
                            editingGuestIndex!,
                            findTemplate($any($event.target).value)
                          )
                        "
                      >
                        <option value="">— Choose a saved guest —</option>
                        <option *ngFor="let t of templates" [value]="t.id">
                          {{ t.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="guest-section-title">Guest identity</div>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label fs-14">Full name *</label>
                      <input
                        class="form-control"
                        formControlName="full_name"
                        placeholder="As written on the document"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Date of birth</label>
                      <input
                        type="date"
                        class="form-control"
                        formControlName="date_of_birth"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Gender</label>
                      <select class="form-select" formControlName="gender">
                        <option value="">—</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div class="guest-section-title">Identity document</div>
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label fs-14">Nationality</label>
                      <input
                        class="form-control"
                        formControlName="nationality"
                        placeholder="e.g. Indonesia"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Document type</label>
                      <select
                        class="form-select"
                        formControlName="document_type"
                      >
                        <option value="passport">Passport</option>
                        <option value="id_card">ID Card</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Document number *</label>
                      <input
                        class="form-control"
                        formControlName="document_number"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Expiry date</label>
                      <input
                        type="date"
                        class="form-control"
                        formControlName="document_expiry"
                      />
                    </div>
                    <div class="col-md-12">
                      <label class="form-label fs-14"
                        >Upload document image</label
                      >
                      <input
                        type="file"
                        accept="image/*,.pdf"
                        class="form-control"
                        (change)="
                          onDocumentSelected(editingGuestIndex!, $event)
                        "
                      />
                      <small
                        class="text-muted"
                        *ngIf="eg.get('document_file_name')?.value"
                      >
                        Selected: {{ eg.get("document_file_name")?.value }}
                        <a
                          *ngIf="eg.get('document_view_token')?.value"
                          [href]="getDocumentUrl(editingGuestIndex!)"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="ms-2"
                        >
                          View
                        </a>
                      </small>
                      <div
                        *ngIf="eg.get('document_view_token')?.value && isImageFile(eg.get('document_file_url')?.value)"
                        class="mt-2"
                      >
                        <a
                          [href]="getDocumentUrl(editingGuestIndex!)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            [src]="getDocumentUrl(editingGuestIndex!)"
                            alt="Document preview"
                            style="max-width: 200px; max-height: 140px; border: 1px solid var(--bs-border-color-translucent); border-radius: 4px;"
                          />
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="guest-section-title">Emergency contact</div>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label fs-14"
                        >Emergency contact name</label
                      >
                      <input
                        class="form-control"
                        formControlName="emergency_contact_name"
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fs-14"
                        >Emergency contact phone</label
                      >
                      <input
                        class="form-control"
                        formControlName="emergency_contact_phone"
                      />
                    </div>
                  </div>

                  <div class="guest-section-title">Pick-up &amp; drop-off</div>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label fs-14">Pick-up location</label>
                      <input
                        class="form-control"
                        formControlName="pickup_location"
                        placeholder="e.g. Bintang Flores Hotel, Labuan Bajo"
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fs-14"
                        >Drop-off location after trip</label
                      >
                      <input
                        class="form-control"
                        formControlName="dropoff_location"
                        placeholder="e.g. Komodo Airport (LBJ)"
                      />
                    </div>
                    <div class="col-md-12">
                      <small class="text-muted">
                        Where we should collect this guest before the trip and
                        drop them off afterwards. Leave blank to use the
                        default harbour meeting point.
                      </small>
                    </div>
                  </div>

                  <div class="guest-section-title">Trip preferences</div>
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label fs-14"
                        >Dietary preferences</label
                      >
                      <input
                        class="form-control"
                        formControlName="dietary"
                        placeholder="e.g. Vegetarian, no pork"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Allergies</label>
                      <input
                        class="form-control"
                        formControlName="allergy"
                        placeholder="e.g. Seafood, nuts"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Dive certification</label>
                      <input
                        class="form-control"
                        formControlName="dive_certification"
                        placeholder="e.g. Open Water, Advanced, None"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label fs-14">Fins / flipper size</label>
                      <input
                        class="form-control"
                        formControlName="flipper_size"
                        placeholder="e.g. EU 42-43, M"
                      />
                    </div>
                    <div class="col-md-12">
                      <label class="form-label fs-14">Medical notes</label>
                      <textarea
                        class="form-control"
                        rows="2"
                        formControlName="medical_notes"
                        placeholder="Anything the crew should know — medication, conditions, mobility"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    (click)="saveAsTemplate(editingGuestIndex!)"
                  >
                    <i class="fa fa-bookmark me-1"></i> Save as template
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="closeGuestModal()"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show"></div>
      </ng-container>

      <div class="row mb-4">
        <div class="col-md-12 text-start">
          <h5 style="color: var(--warna-2)" class="mb-1">Order Info</h5>
        </div>
      </div>

      <div class="row gy-3">
        <div class="col-lg-4">
          <h5 class="fs-14">Booking ID</h5>
          <p class="text-gray-6 fs-16 text-secondary">{{ kodeBooking }}</p>
        </div>
        <div class="col-lg-4">
          <h5 class="fs-14">Payment Method</h5>
          <p class="text-gray-6 fs-16 text-secondary">
            {{ getPaymentMethodLabel(bookings?.metode_pembayaran) }}
          </p>
        </div>
        <div class="col-lg-4">
          <div
            class="w-100 mb-3"
            *ngIf="bookings?.BookingAcc?.length > 0; else noAccomodation"
          >
            <div
              *ngFor="let room of bookings?.BookingAcc"
              class="d-flex justify-content-between align-items-center"
            >
              <span>{{ room.name }}</span>
              <span class="price">IDR {{ room.price | number }}</span>
            </div>

            <div
              *ngIf="bookings?.credit_card_fee && bookings.credit_card_fee > 0"
              class="d-flex justify-content-between align-items-center mt-2"
            >
              <small class="text-muted fst-italic"
                >Includes 3% credit card fee</small
              >
              <span class="price"
                >IDR {{ bookings.credit_card_fee | number }}</span
              >
            </div>
          </div>

          <ng-template #noAccomodation>
            <div class="w-100 mb-3">
              <div class="d-flex justify-content-between align-items-center">
                <span>Adventure</span>
                <span class="price"
                  >IDR
                  {{
                    bookings?.total - bookings.credit_card_fee | number
                  }}</span
                >
              </div>

              <div
                *ngIf="
                  bookings?.credit_card_fee && bookings.credit_card_fee > 0
                "
                class="d-flex justify-content-between align-items-center mt-2"
              >
                <small class="text-muted fst-italic"
                  >Includes 3% credit card fee</small
                >
                <span class="price"
                  >IDR {{ bookings.credit_card_fee | number }}</span
                >
              </div>
            </div>
          </ng-template>

          <div class="row border-top g-1 mb-3 pb-3 d-flex">
            <div class="col-md-6">
              <span><strong>Total :</strong></span>
            </div>
            <div class="col-md-6 text-end">
              <span
                ><strong>{{
                  "IDR " + (bookings?.total | number)
                }}</strong></span
              >
            </div>
          </div>
        </div>

        <hr />
      </div>

      <div class="row mt-4 mb-4" *ngIf="bookings?.status === 'WAITING PAYMENT'">
        <div class="col-md-12 text-center">
          <button class="btn btn-primary" (click)="openPaymentModal()">
            Make Payment
          </button>
        </div>
      </div>

      <div class="row mt-4 mb-4" *ngIf="bookings?.status === 'PAID'">
        <div class="col-md-12 text-center">
          <button class="btn btn-success" (click)="openPaymentModal()">
            Invoice
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  *ngIf="isModalVisible"
  class="modal fade show"
  style="display: block"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Cancellation Details</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div [innerHTML]="ketBatal"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Payment -->
<div
  class="modal fade"
  id="paymentModal"
  tabindex="-1"
  aria-labelledby="paymentModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="paymentModalLabel">
          Select Payment Method
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p>Please select a payment method:</p>
        <div class="list-group">
          <button
            type="button"
            class="list-group-item list-group-item-action"
            (click)="selectPaymentMethod('Credit Card')"
          >
            💳 Credit Card
          </button>
          <button
            type="button"
            class="list-group-item list-group-item-action"
            (click)="selectPaymentMethod('Virtual Account')"
          >
            🏦 Virtual Account
          </button>
          <button
            type="button"
            class="list-group-item list-group-item-action"
            (click)="selectPaymentMethod('Bank Transfer')"
          >
            🔄 Bank Transfer
          </button>
          <button
            type="button"
            class="list-group-item list-group-item-action"
            (click)="selectPaymentMethod('E-Wallet')"
          >
            📱 E-Wallet
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
